let NEXT_ID = 0;
export const __nextID = () => NEXT_ID++;
/**
 * @param prefix -
 * @param opts -
 *
 * @internal
 */
export const __optsWithID = (prefix, opts) => ((!opts || !opts.id ? { ...opts, id: prefix + "-" + __nextID() } : opts));
